

<div class="col-lg-12 nopadding">
      <app-filter-panel [GridColumns]="GridColumns" [DefaultFilterArray]="defaultFilterArray"
        (FilterEvent)="filterApplyFilterEvent($event)" [ResetLabel]="isFilterLabelReset"
        (FilterEventClearSymbol)="FilterEventClearSymbol($event)">
      </app-filter-panel>
    </div>
    <!-- Filter Quick Fields Panel Code -->
<div class="col-lg-12 nopadding">
    <app-symbol-panel [SymbolArray]="SymbolsArray" [CodeArray]="CodesArray" [ResetLabel]="ResetLabel"
      [rowCount]="totalRecords" [rowCountSymbol]="totalRecords" (ActiveSymbolEvent)="setActiveSymbolEvent($event)"
      >
    </app-symbol-panel>
  </div>
    <div class="col-lg-12 nopadding">
      @if(isLoadingResults) {
      <div class="example-loading-shade">
        <mat-spinner></mat-spinner>
      </div>
      }
      @if(dataset) {
      <p-table #dt 
        [value]="dataset" 
        [columns]="cols" 
        [resizableColumns]="true" 
        [lazy]="true" 
        (onPage)="changePage($event)" 
        [sortOrder]="constantService.DEFAULT_SORDORDER_ASC" 
        [(selection)]="selectedRow"
        [paginator]="true" 
        selectionMode="multiple" 
        appendTo="body" 
        alwaysShowPaginator="true" 
        paginatorPosition="both"
        showCurrentPageReport="true" 
        [rows]="constantService.DEFAULT_ROWSIZE" 
        [totalRecords]="totalRecords"
        [pageLinks]="constantService.DEFAULT_PAGELINKS" 
        sortMode="multiple"
        [rowsPerPageOptions]="constantService.DEFAULT_ROWSPERPAGEOPTION"
        styleClass = "common-grid-table"
        [scrollable]="true" scrollHeight="60vh">
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{constantService.NO_RECORDFOUND_MSG}}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="header" let-columns let-rowIndex=rowIndex>
          <tr>
            <th id="tableCheckbox" style="width: 3em">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            @for(col of columns; track col + '-'+ $index;) {
            <th id="colHeader" pResizableColumn [pSortableColumn]="col.field"
              [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
              {{col.header}}
            </th>}
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
          <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex" class="ui-widget-NoUpdated-row">
            <td style="width: 3em;padding-left: 6px !important;">
              <p-tableCheckbox  [id]="'checkbox'+ rowIndex" [value]="row"></p-tableCheckbox>
            </td>
            @for(col of columns; track col.field + '-'+ $index; let idx = $index) {
            <td class="ui-resizable-column"
              [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay': col.header === 'action' ? 'ui-action' : '' ">
              @if(col.header === 'action') {
              <span>
                <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Add Comment" [matTooltipShowDelay]="1000"
                matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-comment"
                [id]="'comment'+ rowIndex"  (click)="addComment(row);"></p-button>
              </span>
              }
              @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float'){
              <span >
                @if((col.header) !=='OrderID' && (col.header) !=='Exception'){
                <span>
                  {{row[col.field] !== 'null' ? row[col.field]: ""}}
                </span>
                }
                @if((col.header) =='OrderID'){
                <span>
                  <a matTooltip="View Order Details" [matTooltipShowDelay]="1000" appendTo="body" [id]="'OrderID'+ rowIndex" 
                  (click)="openOrderViewer(row)">
                    {{row[col.field]}}
                  </a>
                </span>
                }
                @if((col.header) =='Exception'){
                <span>
                  <a matTooltip="View Exception Details" [matTooltipShowDelay]="1000" matTooltipPosition="after" appendTo="body" [id]="'OrderID'+ rowIndex" 
                  class="exceptionLink" (click)="openExceptionDetails(row)">
                    {{row[col.field]}}
                  </a>
                </span>
                }
              </span>
              }
    
              <!-- set int  -->
               @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float'){
              <span style="float:right;">
                {{row[col.field] * 1}} 
              </span>
              }
            </td>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="paginatorright">
          Total Records: {{dataset.length == 0? 0 : totalRecords}}
    
        </ng-template>
        <ng-template pTemplate="paginatorleft">
          <!-- Page No : {{pageNumber }} -->
          Showing {{dataset.length == 0? 0 : startLimit + 1}} to {{dataset.length
             < rowcount ? dataset.length < startLimit ? endLimit : dataset.length : endLimit}} entries
        </ng-template>
      </p-table>
      }
    </div>
@if(isShowExceptionDetails){
<app-exception-details [defaultFilterArray]="defaultFilterArray" [pageName]="pageName" [selectedRow]="selectedRowDetail" (closeDialog)="isShowExceptionDetails = false">
</app-exception-details>
}
<!-- DialogBox for Comment Operation -->
@if(isDisplayCommentDialog){
<app-exception-comment [selectedRow]="selectedRow" [userList]="userList" (closeDialog)="isDisplayCommentDialog = false" (updateExceptionStatus)="updateClientDataStaus($event)">
</app-exception-comment>
}